import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

const ICONS = {
  'search': 'fas fa-search',
  'signOut': 'fas fa-sign-out-alt',
  'back': 'fas fa-arrow-left',
  'delete': 'fas fa-trash-alt',
  'arrow-right': 'fas fa-arrow-right',
  'building': 'fas fa-building',
  'user': 'far fa-user',
  'edit': 'fas fa-edit',
  'usersCog': 'fas fa-users-cog'
}

Vue.use(Vuetify, {
  iconfont: 'fa', // 'md' || 'mdi' || 'fa' || 'fa4'
  icons: ICONS
})
